'use client';

import { useTranslation } from '@/lib/i18n/i18n.client';

import { PricingSectionContentProps } from '@/blocks/PricingSection/types';

import PricingSectionCardColumn from './Components/PricingSectionCardColumn';
import PricingSectionHeaderColumnCardCell from './Components/PricingSectionHeaderColumnBadge';
import PricingSectionPriceCardCell from './Components/PricingSectionPriceCardCell';

const PricingSectionDesktop = (props: PricingSectionContentProps) => {
  const { columns, headerColumn, contactSalesColumns } = props;
  const { texts } = useTranslation();

  return (
    <div className='w-full flex-1 flex gap-x-2'>
      <div className='flex-1 flex flex-col gap-y-[1px] rounded overflow-hidden border-[1px] border-transparent'>
        <PricingSectionHeaderColumnCardCell
          isHeaderCell
          primaryText={texts.pricing_section.header_column_primary_text_desktop}
          secondaryText={texts.pricing_section.header_column_secondary_text}
        />
        {headerColumn?.rows?.map((row, index) => (
          <PricingSectionHeaderColumnCardCell key={index} {...row} />
        ))}

        <PricingSectionPriceCardCell
          isHeaderCell={false}
          isHeaderColumn={true}
          secondaryText={texts.pricing_section.rate_limit}
        />
        <PricingSectionHeaderColumnCardCell
          isHeaderCell={false}
          isHeaderColumn={true}
          secondaryText={texts.pricing_section.all_prices_shown_are_per_1k_req}
        />
      </div>

      {columns?.map((column, index) => (
        <PricingSectionCardColumn key={`${column.cardHeader}-${index}`} {...column} />
      ))}
      {contactSalesColumns?.map((column, index) => (
        <PricingSectionCardColumn key={`contact-${column.cardHeader}-${index}`} {...column} />
      ))}
    </div>
  );
};

export default PricingSectionDesktop;
